import { memo } from 'react'
import { BeatLoader } from 'react-spinners'
// import ReactInputMask from 'react-input-mask'

import css from './input.module.scss'
import { IInput, InputSizeType } from './input.type'


/** Текстовое поле */
export default memo(({ 
    id, name, type = 'text', placeholder, autoComplete = 'off', prefix, suffix, variant = 'primary', 
    mask, maskChar, size, width, maxWidth, isReadOnly = false, isDisabled = false, isLoading = false, 
    paddingLeft, paddingRight, value, onChange, textAlign = 'left' , refInput
}: IInput) => {
    const getSizeClassName = (size?: InputSizeType) => {
        switch (size) {
            case 'lg': return css.lg
            case 'md': return css.md
            case 'sm': return css.sm
            case 'xs': return css.xs
            default: return css.md
        }
    }

    const inputType = (type: React.HTMLInputTypeAttribute | 'mask') => {
        switch (type) {
            case 'mask': return (''
                // <ReactInputMask autoFocus ref={refInput} maskChar={maskChar} mask={mask || ''} id={id} name={name} placeholder={placeholder} value={value?.toString()} onChange={onChange} autoComplete={autoComplete} readOnly={isReadOnly} disabled={isDisabled} className={`${getSizeClassName(size)}`} style={{textAlign: textAlign, letterSpacing: '10px', fontSize: '22px'}} />
            )
            default: return (<input ref={refInput} id={id} name={name} type={type} placeholder={placeholder} value={value?.toString()} onChange={onChange} autoComplete={autoComplete} readOnly={isReadOnly} disabled={isDisabled} className={`${getSizeClassName(size)}`} style={{textAlign: textAlign}} />)
        }
    }


    return <section className={`${css[variant]} ${getSizeClassName(size)} ${isDisabled && css['disabled']}`} style={{ width: width, maxWidth: maxWidth, paddingRight: paddingRight, paddingLeft: paddingLeft }}>
        {prefix}
        {inputType(type)}
        {suffix}

        {isLoading && <div className={css.isLoading}><BeatLoader size={10} loading={isLoading} color='#f34e2e' /></div>}
    </section>
})